'use client'

import { StickyContentProvider } from '@pienso/sticky-content-provider'
import { ReactNode } from 'react'

export function Providers({ children }: { children: ReactNode }) {
  return <StickyContentProvider>{children}</StickyContentProvider>
}
